export default __webpack_public_path__ + "images/ccf8bad5e356313fbd240deec3a9a6b6-illustration-eui-hero-500-shadow.svg";